

export async function textToFile(text: string, fileName:string): Promise<File> {
  return new Promise((resolve, reject) => {
    const blob = new Blob([text], { type: 'text/plain' });
    const file = new File([blob], fileName+'.txt',{ type: 'text/plain' });
    resolve(file);
  })}
  